module.exports = __webpack_public_path__ + "static/media/close-arrow.e1073316.svg";